/**
* Determines whether the String argument is a valid CSS hex color code.
* 
* @param {String} hexColor 
* @returns {Boolean} - If true, then the passed-in string is a valid CSS hex color code.
*/
export function isValidHexColor(hexColor) {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hexColor);
}
